// NHTSA answers 200 and echoes the VIN even when it cannot decode it, so empty Make/Model/Year means "nothing decoded".
// ErrorCode "1" (bad check digit) and "400" (invalid characters) still return data decoded from the VIN pattern.
export const normalizeDecodedVin = (asset) => {
	if (!asset?.VIN || !(asset.Make || asset.Model || asset.ModelYear)) {
		return { error: true };
	}

	const errorCodes = String(asset.ErrorCode ?? "").split(",").map((code) => code.trim());
	const liters = parseFloat(asset.DisplacementL);
	// Only the check digit failed (not the characters), so the more specific message can be shown
	const checkDigitError = errorCodes.includes("1") && !errorCodes.includes("400");

	return {
		...asset,
		// NHTSA sends e.g. "2.998832712"; the Engine Liters field only holds 5 characters
		DisplacementL: Number.isFinite(liters) ? String(Number(liters.toFixed(1))) : "",
		invalidVin: errorCodes.includes("1") || errorCodes.includes("400"),
		checkDigitError,
	};
};
